// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/station.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Region } from "./customer_pb";
import { file_v1_customer } from "./customer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/station.proto.
 */
export const file_v1_station: GenFile = /*@__PURE__*/
  fileDesc("ChB2MS9zdGF0aW9uLnByb3RvEgJ2MSJtCg1TdGF0aW9uTWFzdGVyEgoKAmlkGAEgASgFEgwKBG5hbWUYAiABKAkSGgoGcmVnaW9uGAMgASgOMgoudjEuUmVnaW9uEg8KB3dlZWtkYXkYBCABKAkSFQoNc3RhdGlvbl9pbmRleBgFIAEoBSI3ChJTaW5nbGVTdGF0aW9uQWxpYXMSEgoKc3RhdGlvbl9pZBgBIAEoBRINCgVhbGlhcxgCIAEoCSJVChFNdWx0aVN0YXRpb25BbGlhcxIaCgZyZWdpb24YASABKA4yCi52MS5SZWdpb24SFQoNc3RhdGlvbl9jb3VudBgCIAEoBRINCgVhbGlhcxgDIAEoCSIaChhMaXN0U3RhdGlvbk1hc3RlclJlcXVlc3QiQAoZTGlzdFN0YXRpb25NYXN0ZXJSZXNwb25zZRIjCghzdGF0aW9ucxgBIAMoCzIRLnYxLlN0YXRpb25NYXN0ZXIiGQoXTGlzdFN0YXRpb25BbGlhc1JlcXVlc3QieAoYTGlzdFN0YXRpb25BbGlhc1Jlc3BvbnNlEi4KDnNpbmdsZV9hbGlhc2VzGAEgAygLMhYudjEuU2luZ2xlU3RhdGlvbkFsaWFzEiwKDW11bHRpX2FsaWFzZXMYAiADKAsyFS52MS5NdWx0aVN0YXRpb25BbGlhcyJ3ChdTYXZlU3RhdGlvbkFsaWFzUmVxdWVzdBIuCg5zaW5nbGVfYWxpYXNlcxgBIAMoCzIWLnYxLlNpbmdsZVN0YXRpb25BbGlhcxIsCg1tdWx0aV9hbGlhc2VzGAIgAygLMhUudjEuTXVsdGlTdGF0aW9uQWxpYXMieAoYU2F2ZVN0YXRpb25BbGlhc1Jlc3BvbnNlEi4KDnNpbmdsZV9hbGlhc2VzGAEgAygLMhYudjEuU2luZ2xlU3RhdGlvbkFsaWFzEiwKDW11bHRpX2FsaWFzZXMYAiADKAsyFS52MS5NdWx0aVN0YXRpb25BbGlhczKGAgoOU3RhdGlvblNlcnZpY2USUgoRTGlzdFN0YXRpb25NYXN0ZXISHC52MS5MaXN0U3RhdGlvbk1hc3RlclJlcXVlc3QaHS52MS5MaXN0U3RhdGlvbk1hc3RlclJlc3BvbnNlIgASTwoQTGlzdFN0YXRpb25BbGlhcxIbLnYxLkxpc3RTdGF0aW9uQWxpYXNSZXF1ZXN0GhwudjEuTGlzdFN0YXRpb25BbGlhc1Jlc3BvbnNlIgASTwoQU2F2ZVN0YXRpb25BbGlhcxIbLnYxLlNhdmVTdGF0aW9uQWxpYXNSZXF1ZXN0GhwudjEuU2F2ZVN0YXRpb25BbGlhc1Jlc3BvbnNlIgBCKFomZ2l0aHViLmNvbS9kdWNidC90dC1nby9nZW4vcHJvdG8vdjE7djFiBnByb3RvMw", [file_v1_customer]);

/**
 * StationMaster is one draw slot of the weekly schedule.
 *
 * @generated from message v1.StationMaster
 */
export type StationMaster = Message<"v1.StationMaster"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: v1.Region region = 3;
   */
  region: Region;

  /**
   * sunday..saturday, or common for mb
   *
   * @generated from field: string weekday = 4;
   */
  weekday: string;

  /**
   * @generated from field: int32 station_index = 5;
   */
  stationIndex: number;
};

/**
 * Describes the message v1.StationMaster.
 * Use `create(StationMasterSchema)` to create a new message.
 */
export const StationMasterSchema: GenMessage<StationMaster> = /*@__PURE__*/
  messageDesc(file_v1_station, 0);

/**
 * SingleStationAlias maps an alias to one draw slot.
 *
 * @generated from message v1.SingleStationAlias
 */
export type SingleStationAlias = Message<"v1.SingleStationAlias"> & {
  /**
   * @generated from field: int32 station_id = 1;
   */
  stationId: number;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;
};

/**
 * Describes the message v1.SingleStationAlias.
 * Use `create(SingleStationAliasSchema)` to create a new message.
 */
export const SingleStationAliasSchema: GenMessage<SingleStationAlias> = /*@__PURE__*/
  messageDesc(file_v1_station, 1);

/**
 * MultiStationAlias maps an alias to the first station_count stations of the day.
 *
 * @generated from message v1.MultiStationAlias
 */
export type MultiStationAlias = Message<"v1.MultiStationAlias"> & {
  /**
   * @generated from field: v1.Region region = 1;
   */
  region: Region;

  /**
   * @generated from field: int32 station_count = 2;
   */
  stationCount: number;

  /**
   * @generated from field: string alias = 3;
   */
  alias: string;
};

/**
 * Describes the message v1.MultiStationAlias.
 * Use `create(MultiStationAliasSchema)` to create a new message.
 */
export const MultiStationAliasSchema: GenMessage<MultiStationAlias> = /*@__PURE__*/
  messageDesc(file_v1_station, 2);

/**
 * @generated from message v1.ListStationMasterRequest
 */
export type ListStationMasterRequest = Message<"v1.ListStationMasterRequest"> & {
};

/**
 * Describes the message v1.ListStationMasterRequest.
 * Use `create(ListStationMasterRequestSchema)` to create a new message.
 */
export const ListStationMasterRequestSchema: GenMessage<ListStationMasterRequest> = /*@__PURE__*/
  messageDesc(file_v1_station, 3);

/**
 * @generated from message v1.ListStationMasterResponse
 */
export type ListStationMasterResponse = Message<"v1.ListStationMasterResponse"> & {
  /**
   * @generated from field: repeated v1.StationMaster stations = 1;
   */
  stations: StationMaster[];
};

/**
 * Describes the message v1.ListStationMasterResponse.
 * Use `create(ListStationMasterResponseSchema)` to create a new message.
 */
export const ListStationMasterResponseSchema: GenMessage<ListStationMasterResponse> = /*@__PURE__*/
  messageDesc(file_v1_station, 4);

/**
 * @generated from message v1.ListStationAliasRequest
 */
export type ListStationAliasRequest = Message<"v1.ListStationAliasRequest"> & {
};

/**
 * Describes the message v1.ListStationAliasRequest.
 * Use `create(ListStationAliasRequestSchema)` to create a new message.
 */
export const ListStationAliasRequestSchema: GenMessage<ListStationAliasRequest> = /*@__PURE__*/
  messageDesc(file_v1_station, 5);

/**
 * @generated from message v1.ListStationAliasResponse
 */
export type ListStationAliasResponse = Message<"v1.ListStationAliasResponse"> & {
  /**
   * @generated from field: repeated v1.SingleStationAlias single_aliases = 1;
   */
  singleAliases: SingleStationAlias[];

  /**
   * @generated from field: repeated v1.MultiStationAlias multi_aliases = 2;
   */
  multiAliases: MultiStationAlias[];
};

/**
 * Describes the message v1.ListStationAliasResponse.
 * Use `create(ListStationAliasResponseSchema)` to create a new message.
 */
export const ListStationAliasResponseSchema: GenMessage<ListStationAliasResponse> = /*@__PURE__*/
  messageDesc(file_v1_station, 6);

/**
 * SaveStationAliasRequest carries the caller's complete alias set. Everything not listed is deleted.
 *
 * @generated from message v1.SaveStationAliasRequest
 */
export type SaveStationAliasRequest = Message<"v1.SaveStationAliasRequest"> & {
  /**
   * @generated from field: repeated v1.SingleStationAlias single_aliases = 1;
   */
  singleAliases: SingleStationAlias[];

  /**
   * @generated from field: repeated v1.MultiStationAlias multi_aliases = 2;
   */
  multiAliases: MultiStationAlias[];
};

/**
 * Describes the message v1.SaveStationAliasRequest.
 * Use `create(SaveStationAliasRequestSchema)` to create a new message.
 */
export const SaveStationAliasRequestSchema: GenMessage<SaveStationAliasRequest> = /*@__PURE__*/
  messageDesc(file_v1_station, 7);

/**
 * @generated from message v1.SaveStationAliasResponse
 */
export type SaveStationAliasResponse = Message<"v1.SaveStationAliasResponse"> & {
  /**
   * @generated from field: repeated v1.SingleStationAlias single_aliases = 1;
   */
  singleAliases: SingleStationAlias[];

  /**
   * @generated from field: repeated v1.MultiStationAlias multi_aliases = 2;
   */
  multiAliases: MultiStationAlias[];
};

/**
 * Describes the message v1.SaveStationAliasResponse.
 * Use `create(SaveStationAliasResponseSchema)` to create a new message.
 */
export const SaveStationAliasResponseSchema: GenMessage<SaveStationAliasResponse> = /*@__PURE__*/
  messageDesc(file_v1_station, 8);

/**
 * StationService manages a user's station aliases over the immutable station master.
 *
 * @generated from service v1.StationService
 */
export const StationService: GenService<{
  /**
   * @generated from rpc v1.StationService.ListStationMaster
   */
  listStationMaster: {
    methodKind: "unary";
    input: typeof ListStationMasterRequestSchema;
    output: typeof ListStationMasterResponseSchema;
  },
  /**
   * @generated from rpc v1.StationService.ListStationAlias
   */
  listStationAlias: {
    methodKind: "unary";
    input: typeof ListStationAliasRequestSchema;
    output: typeof ListStationAliasResponseSchema;
  },
  /**
   * @generated from rpc v1.StationService.SaveStationAlias
   */
  saveStationAlias: {
    methodKind: "unary";
    input: typeof SaveStationAliasRequestSchema;
    output: typeof SaveStationAliasResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_station, 0);

